<script>
/**
 * Descripción: Pantalla de Login
 *
 * @displayName loginViewComponent
 */
import BaseLocalHelper from '@/helpers/BaseLocalHelper.js';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import { mapActions } from 'vuex';

const TheError = () => import('@/components/core/layouts/TheError.vue');

export default {
  name: 'loginViewComponent',

  components: {
    TheError
  },

  data() {
    return {
      loading: false,
      showPassword: false,
      lblbtnLogin: BaseLocalHelper.$_LabelBtnSigIn,
      Bool: true,
      entity: this.$_Object()
    };
  },

  created() {
    localStorage.removeItem('user');
  },

  methods: {
    /**
     * Obj de la pantalla
     */
    $_Object() {
      return {
        userName: undefined,
        password: undefined
      };
    },

    /**
     * Configuración authentication
     */
    ...mapActions('authentication', ['login']),

    $_authenticate() {
      this.loading = true;
      let object = BaseArrayHelper.SetObject({}, this.entity);
      this.login(object);
      this.loading = false;
    },

    $_Password() {
      this.showPassword = !this.showPassword;
    }
  }
};
</script>

<template>
  <TheError>
    <div slot="RenderBody">
      <img src="@/assets/SaasManagerLogo.svg" height="100px" />
      <BaseForm :method="$_authenticate" :labelBtn="lblbtnLogin" :login="Bool">
        <div slot="body">
          <!-- @ Use Loanding... -->
          <BaseSkeletonLoader v-if="loading" type="article, actions" />
          <v-row v-if="!loading">
            <v-col cols="12">
              <BaseInput
                label="Usuario"
                prepend-icon="mdi-account-circle"
                v-model="entity.userName"
                :validate="['text']"
                required
                autofocus
              />
            </v-col>

            <v-col cols="12">
              <BaseInput
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :clickAppend="$_Password"
                v-model="entity.password"
                :validate="['text']"
                required
              />
            </v-col>
          </v-row>
        </div>
      </BaseForm>
    </div>
  </TheError>
</template>
